import { Button, Classes, H3, Menu } from "@blueprintjs/core";
import { Popover2 } from "@blueprintjs/popover2";
import { logoutUser } from "controllers/user/action";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { constructPath, findRoute, RootProps } from "routes";
import Navigation, { isActive } from "./Navigation";
import { Fragment, useState } from "react";
import { selectCurrentModel } from "controllers/common/action";
import MobileOverlay from "./MobileOverlay";
import ModelTypeTag from "components/ModelTypeTag";
import SharedModelTag from "components/SharedModelTag";

export default function AfterLogin(props: RootProps) {
  const { routes, currentRoute, user } = props;
  const nodeDash = findRoute(routes, "Dashboard");
  const nodeSettings = findRoute(routes, "AccountSettings");
  const location = useLocation();
  const hidden = location.pathname.includes("/dashboard");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleLogout = () => {
    dispatch(logoutUser());
    navigate("/");
  };
  const currentModel = useSelector(selectCurrentModel);
  const showModelName = findRoute(routes, "Model")?.data?.name === currentRoute?.name;
  const isModelRoute = currentRoute?.name === "Model";

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  return (
    <Fragment>
      <div className={`header after${isModelRoute ? " header--fullwidth" : ""}`}>
        <div className="header-left">
          <Link className="eset-logo" to={constructPath(findRoute(routes, "InfoHome"))}>
            <img className="logo--small" src="images/ESET_Logo.svg" alt="Small ESET Logo" />
            <img src="images/ESET_Mark.svg" alt="ESET" />
          </Link>
          {!hidden && <Navigation {...props} showChildren />}
          <div className="header-name">
            {showModelName && currentModel && (
              <>
                <H3>{currentModel.modelName ? currentModel.modelName : "Unnamed New Model"}</H3>
                <ModelTypeTag modelType={currentModel.modelType ?? ""} />
                {currentModel.isShared && <SharedModelTag variant="withMe" />}
                {!currentModel.isShared && currentModel.sharedWithOthers && (
                  <SharedModelTag variant="byMe" shareCount={currentModel.shareCount} />
                )}
              </>
            )}
          </div>
        </div>
        <div className="header-right">
          <Popover2
            key="user"
            placement="bottom-start"
            interactionKind="click"
            minimal
            content={
              <Fragment>
                <Menu className={`${Classes.POPOVER_DISMISS} subNav`}>
                  <Link key={nodeSettings?.data?.name} to={constructPath(nodeSettings)}>
                    <Button
                      minimal
                      text={nodeSettings?.data?.label}
                      active={nodeSettings ? isActive(location, nodeSettings) : false}
                    />
                  </Link>
                </Menu>
                <Menu className={`${Classes.POPOVER_DISMISS} subNav`}>
                  <Button minimal text="Log Out" onClick={handleLogout} />
                </Menu>
              </Fragment>
            }
          >
            <Button key="userName" text={user ? user.firstName ?? user.email : "UserName"} minimal intent="primary" icon="user" />
          </Popover2>

          {!hidden && (
            <Link key={nodeDash?.data?.name} to={constructPath(nodeDash)}>
              <Button
                key={nodeDash?.data?.name}
                intent="primary"
                text="Go to evaluation tool"
                className="header-right--wb"
              />
            </Link>
          )}
        </div>

        <Button
          className="mobile-menu-button"
          icon={isMobileMenuOpen ? "cross" : "menu"}
          minimal
          intent="primary"
          onClick={toggleMobileMenu}
        />

        <MobileOverlay
          {...props}
          isOpen={isMobileMenuOpen}
          onClose={() => setIsMobileMenuOpen(false)}
        />
      </div>
    </Fragment>
  );
}
